import { render } from "./PwaPrompt.vue?vue&type=template&id=1b86bea0"
import script from "./PwaPrompt.vue?vue&type=script&lang=js"
export * from "./PwaPrompt.vue?vue&type=script&lang=js"

import "./PwaPrompt.vue?vue&type=style&index=0&id=1b86bea0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__